"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessContext = void 0;
var tslib_1 = require("tslib");
// @ts-nocheck
var react_1 = tslib_1.__importDefault(require("react"));
exports.AccessContext = react_1.default.createContext(null);
exports.default = exports.AccessContext;
